import * as React from "react"
import { withTranslation } from "react-i18next"

const Error = (props: any) => (
  <div style={{ padding: 30 }}>
    <p>
      {props.t("app-error.sorry1")}
      <span role="img" aria-label="emoji">
        {" "}
        😳 ⚠️
      </span>
      {props.t("app-error.sorry2")}
    </p>
    <p>{props.t("app-error.reload")}</p>
  </div>
)

export default withTranslation()(Error)
